import React from 'react';
import ProtectedRoute from './ProtectedRoute';

export const WithPermissionCheck = (Component) => {
    return (
        <ProtectedRoute>
            <Component />
        </ProtectedRoute>
    );
};